export default __webpack_public_path__ + "static/media/scrap.be96e202.png";